import IQACDynamicPage from '../../DynamicPage/IQACDynamicPage';
import pages from "../../Pages.json";
import "./SportsAdvisory.scss";
import TableComponent from '../../../components/Table/TableComponent';

const SportsAdvisory = () => {

    const sportsAdvisory = pages['sports-advisory'][0];
    const columns = ["S.No.", "Name", "Designation & Department", "Position", "Email ID"];
    const rows = [
        { name: "Dr. R .Marimuthu", designation: "Principal", position: "Chairman", email: "nicollege2001@yahoo.co.in" },
        { name: "Mr. J. Jayaraj", designation: "Physical Director", position: "Convenor", email: "jayansheeja2011@gmil.com" },
        { name: "Mr. K. Krishna Prasad", designation: "Asst. Prof., Department of  Computer Science (PG)", position: "Member", email: "vskpnair@gmail.com" },
        { name: "Mr. Lt. V. I. Sree Dev", designation: "Asst. Prof., Department of  English", position: "Member", email: "sreedevambadiyil@gmail.com" },
        { name: "Mr. S. Sivakumar", designation: "Asst. Prof., Department of  Business Management", position: "Member", email: "stsiva2005@gmail.com" },
        { name: "Dr. C. Murugesan", designation: "Asst. Prof., Department of  Mathematics (UG)", position: "Member", email: "kumarithozhanmurugesan@gmail.com" },
    ];

    return (
        <section className="sportsAdvisoryMainContainer">
            <article className="firstSection">
                <IQACDynamicPage
                    title={sportsAdvisory.title}
                    content={sportsAdvisory.content}
                    secondtitle={sportsAdvisory.secondtitle}
                />

                <article>

                    <ul className='point-style'>
                        <li>Promotes physical fitness and well-being among students.</li>
                        <li>Enhances team spirit and leadership skills.</li>
                        <li>Ensures the development of sports infrastructure.</li>
                        <li>Identifies and nurtures talented athletes.</li>
                        <li>Encourages participation in external competitions, enhancing the college's reputation.</li>
                    </ul>

                </article>
            </article>

            <article className="secondSection">
                <h2 style={{ color: "#116C4A" }}>Sports Advisory Members</h2>
                <TableComponent columns={columns} data={rows} />
            </article>
        </section>
    )
}

export default SportsAdvisory
